import React from 'react';

import { Link } from 'react-router-dom';

const BnplFooter = ({ setActiveModal, setOpenModal }) => {
  const openTermsModal = () => {
    setActiveModal('terms');
    setOpenModal(true);
  };

  const openPrivacyModal = () => {
    setActiveModal('privacy');
    setOpenModal(true);
  };

  const openContactModal = () => {
    setActiveModal('contact');
    setOpenModal(true);
  };

  return (
    <div className="bnpl-form__container__footer">
      <a
        href="https://lendistryinteractive.com/terms-of-use/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>
      <a
        href="https://lendistryinteractive.com/privacypolicy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      <Link to="#" onClick={() => openContactModal()}>
        Contact Us
      </Link>
    </div>
  );
};

export default BnplFooter;
